import { getComponent } from "./component-manager";


const renderMoudle = (elementID, moduleWarp) => {
  // 渲染的目标容器
  let containerElement = document.getElementById(elementID);
  // 如果没有找到，会手动创建
  if (!containerElement) {
    const parentContainer = document.getElementById("floorListContainer");
    containerElement = document.createElement("DIV");
    containerElement.setAttribute("id",elementID);
    containerElement.setAttribute("class","flex1ColFloor");
    
    if (parentContainer) {
      parentContainer.appendChild(containerElement);
    }else {
      document.body.appendChild(containerElement);
    }
    
  }

  // 获取组件
  const layout = moduleWarp.data?.layout;
  
  getComponent({
    name:layout,
    moduleWarp,
  }).then((moduleComponet)=>{
    // 开始渲染
    if (moduleComponet) {
      moduleComponet.render({ moduleWarp, containerElement });
    } else {
      console.error("[FreePage] Component did not found: ", layout);
    }
  });
}

export default (pageData, onlyRenderModuleId) => {
  
  if (!pageData) return;

  const { modules = {} } = pageData;

  if (onlyRenderModuleId &&  modules[onlyRenderModuleId]) {
    if (modules[onlyRenderModuleId].rendered) return;
    modules[onlyRenderModuleId].rendered = true;
    renderMoudle(onlyRenderModuleId, modules[onlyRenderModuleId]);
    return;
  }
  
  // 处理数据
  for (const elementID in modules) {
    const moduleWarp = modules[elementID];
    // 标记不允许重复渲染
    if (moduleWarp.rendered) continue;
    moduleWarp.rendered = true;
    
    renderMoudle(elementID, moduleWarp);
    
  }
  // 页面级别 List LoadMore
  if (pageData.fpPageEvents?.length > 0 && !window["__FPListLoaded"]) {
    window["__FPListLoaded"] = true;
    
    getComponent({name:"fp-list"}).then((moduleComponet)=>{
      if (moduleComponet) {
        moduleComponet.render({ fpPageEvents: pageData.fpPageEvents });
      } 
    });
  }

  
};
